import { channelwill } from '@channelwill/sdk'

export const initInChannelwill = () => {
  if (!channelwill.isEmbedded()) return

  if (['dev', 'test'].includes(process.env.PUBLIC_LOLOYAL_APP_ENV || '')) {
    channelwill.env.setEnv('test')
    return
  }

  channelwill.env.setEnv('production')
}
